<template>
  <header class="flex relative">
    <div class=""></div>
    <div class="flex">
      <div class="bg-white pl-5">
        <router-link to="/">
          <img class="h-full w-40" src="@/assets/images/KVG_logo_header.jpg" />
        </router-link>
      </div>
      <div class="slant-header"></div>
    </div>
    <div id="language-wrapper" class="flex items-center relative">
      <button id="current-language" class="chevron-down h-8 w-10" :style="{ background: 'center/contain no-repeat url(' + this.$root.publicPath + 'countries/' + this.$root.language + '.png' + ')' }" @click="toggleMenu()"></button>
      <ul id="language-menu" class="hidden absolute flex flex-col z-40 top-28">
        <language-list-item v-for="language in languages"
        v-bind:key="language.id"
        v-bind:countryCode="language.countryCode"
        v-bind:flagImage="language.flagImage"
        v-bind:text="language.text">
        </language-list-item>
      </ul>
    </div>
    <img class="absolute hidden justify-self-start h-40 right-8 top-20 z-10 md:block" src="@/assets/images/iMfarming.png" />
  </header>
</template>

<style lang="scss" scoped>
  header {
    height: 150px;
    background-color: #999900;
  }
  #current-language {
    position: relative;
    &:after {
      content: "";
      width: 30px;
      height: 30px;
      left: 40px;
      top: 3px;
      position: relative;
      display: inline-block;
    }
    &:focus {
      border: unset;
      outline: unset;
    }
  }
  .chevron-down:after {
    background: no-repeat url("../assets/images/chevron_down.png");
  }
  .chevron-up:after {
    background: no-repeat url("../assets/images/chevron_up.png");
  }
  #language-menu {
    background-color: #F3F0D3;
    right: -35px;
    white-space: nowrap;
    &:before {
      content: "";
      width: 30px;
      height: 30px;
      clip-path: polygon(50% 44%, 0% 100%, 100% 100%);
      background-color: #F3F0D3;
      top: -30px;
      right: 35%;
      position: absolute;
      display: inline-block;
    }
  }
  @media(min-width: 768px) {
    #language-menu {
      right: -66px;
    }
  }
</style>

<script>
import LanguageListItem from '@/components/LanguageListItem.vue'

export default {
  name: 'app-nav',
  components: {
    LanguageListItem
  },
  methods: {
    toggleMenu () {
      var menu = document.getElementById('language-menu')
      var currentLanguage = document.getElementById('current-language')

      if (menu.classList.contains('hidden')) {
        currentLanguage.classList.remove('chevron-down')
        currentLanguage.classList.add('chevron-up')
        menu.classList.remove('hidden')
      } else {
        currentLanguage.classList.remove('chevron-up')
        currentLanguage.classList.add('chevron-down')
        menu.classList.add('hidden')
      }
    }
  },
  data: function () {
    return {
      languages: [
        { id: '1', countryCode: 'IEN', flagImage: 'countries/IEN.png', text: 'International' },
        { id: '2', countryCode: 'GB', flagImage: 'countries/GB.png', text: 'United Kingdom' },
        { id: '3', countryCode: 'DE', flagImage: 'countries/DE.png', text: 'Deutschland' },
        { id: '4', countryCode: 'IT', flagImage: 'countries/IT.png', text: 'Italia' },
        { id: '5', countryCode: 'ES', flagImage: 'countries/ES.png', text: 'España' },
        { id: '6', countryCode: 'FR', flagImage: 'countries/FR.png', text: 'France' },
        { id: '7', countryCode: 'HU', flagImage: 'countries/HU.png', text: 'Magyarország' },
        { id: '8', countryCode: 'PL', flagImage: 'countries/PL.png', text: 'Polska' },
        { id: '9', countryCode: 'NL', flagImage: 'countries/NL.png', text: 'Nederland, België' },
        { id: '10', countryCode: 'RU', flagImage: 'countries/RU.png', text: 'Россия' }
      ]
    }
  }
}
</script>